export default __webpack_public_path__ + "static/media/3_example.74234494.jpg";